import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
export default function PolymerMeltFiltrationApplicationsPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  return <SubPageLayout content={content} />;
}